import type { AloftPrice } from '@aloft/toolkit-shared';
import { orUndefined, schAloftPrice } from '@aloft/toolkit-shared';

export type AdjSalePriceLineItem = {
  label: string;
  adjustment: AloftPrice;
};

/** Builds the line items for the "Adj. Sale Price" breakdown tooltip. */
export const getAdjSalePriceBreakdownLineItems = ({
  concessions,
  termsOfSale,
  dateOfSaleAdjustment,
}: {
  concessions?: unknown;
  termsOfSale?: unknown;
  dateOfSaleAdjustment: AloftPrice;
}): AdjSalePriceLineItem[] => {
  const items: AdjSalePriceLineItem[] = [];

  const parsedConcessions = orUndefined(schAloftPrice.parse)(concessions);
  if (parsedConcessions && parsedConcessions.unitAmount !== 0) {
    items.push({ label: 'Concessions', adjustment: parsedConcessions });
  }

  const parsedTermsOfSale = orUndefined(schAloftPrice.parse)(termsOfSale);
  if (parsedTermsOfSale && parsedTermsOfSale.unitAmount !== 0) {
    items.push({ label: 'Terms of Sale', adjustment: parsedTermsOfSale });
  }

  if (dateOfSaleAdjustment.unitAmount !== 0) {
    items.push({ label: 'Date of Sale', adjustment: dateOfSaleAdjustment });
  }

  return items;
};
